<template>
    <button class="expand-btn" :class="expandBtnClassObject" @click="toggleExpand">
        <slot />
        <v-icon class="expand-btn__icon" :disabled="disabled">{{ name }}</v-icon>
    </button>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    isExpanded: {
        default: false,
        type: Boolean,
    },
    disabled: {
        required: false,
        type: Boolean,
        default: null,
    },
    expandedIcon: {
        required: false,
        type: String,
        default: 'custom:expand_less',
    },
    collapsedIcon: {
        required: false,
        type: String,
        default: 'custom:expand_more',
    },
    background: {
        required: false,
        type: Boolean,
        default: false,
    },
    horizontal: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'default',
    },
});
const emit = defineEmits(['expand']);

// computed once, not reactive to later prop changes — mirrors the original data() behaviour
const expandBtnClassObject = {
    'expand-btn--bg': props.background,
    'expand-btn--disabled': props.disabled,
    'expand-btn--horizontal': props.horizontal,
    [`expand-btn--size-${props.size}`]: true,
};

const name = computed(() => (props.isExpanded ? props.expandedIcon : props.collapsedIcon));

const toggleExpand = () => {
    if (!props.disabled) emit('expand');
};
</script>

<style lang="scss" scoped>
@import '@style/base/_mixins';
@import '@style/base/_variables';

.expand-btn {
    outline: none;
    text-align: center;

    &--disabled {
        cursor: not-allowed;
    }

    &--bg {
        background-color: $promo-primary-colour;
        @include icon-border-radius;
        &:hover {
            background-color: $rtls-secondary-button-hover-colour !important;
        }
        .expand-btn__icon {
            color: $promo-white;
            font-size: 1.5rem;
        }
    }

    &--horizontal {
        transform: rotate(270deg);
    }

    &__icon {
        vertical-align: middle;
        color: $promo-primary-colour;
        width: 1rem;
        height: 1.9rem;
    }

    &--size-small {
        .expand-btn__icon {
            font-size: 1rem;
        }
    }

    &--size-default {
        .expand-btn__icon {
            font-size: 1.5rem;
        }
    }

    &--size-large {
        .expand-btn__icon {
            font-size: 2rem;
        }
    }
}
</style>
